import { Injectable } from '@angular/core';
import { PathConfig } from '../config/path.config';

@Injectable({
  providedIn: 'root'
})
export class ExcelTypeFilterService {

  private config: any = {
    transaction: {
      apiEndpoint: [PathConfig.LOAN_TRANSACTIONS, PathConfig.LOAN_TRANSACTIONS_IMPORTED],
      columns: {
        payment_code: {
          type: 'string',
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'code',
            paramName: ['unique_payment_code','payment_codes']
          }
        },
        payment_effective_date: {
          type: 'date',
          uniqueFilter: {
            identifier: 'payment_date',
            textFieldName: 'payment_date',
            paramName: ['unique_payment_effective_date','payment_effective_dates']
          }
        },
        payment_amount: {
          type: 'currency',
          uniqueFilter: {
            identifier: 'payment_amount',
            textFieldName: 'payment_amount',
            paramName: ['unique_payment_amount','payment_amounts']
          }
        },
        payment_method: {
          type: 'string',
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'source',
            paramName: ['unique_payment_method','payment_methods']
          }
        },
        payment_waterfall_model: {
          type: 'string',
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'code',
            paramName: ['unique_waterfall_code','payment_waterfall_codes']
          }
        },
        payment_status: {
          type: 'string',
          uniqueFilter: {
            identifier: 'payment_status',
            textFieldName: 'payment_status',
            paramName: ['unique_payment_status','payment_statuses']
          }
        },
      }
    },
    activityNote: {
      apiEndpoint: PathConfig.LOAN_ACTIVITY_NOTES,
      columns: {
        activityType: {
          type: 'string',
          uniqueFilter: {
            identifier: 'id',
            textFieldName: 'title',
            paramName: 'unique_activity_type'
          }
        },
      }
    },
  };

  getColumnConfig(table: string, column: string) {
    //console.log('Fetching column config for table:', table, 'and column:', column);
    return this.config?.[table]?.columns?.[column];
  }

  getApiEndpoint(table: string,historicData:any = 0) {
    //console.log('Fetching API endpoint for table:', table, 'and historicData:', historicData);
    //console.log('API endpoint:', this.config?.[table]?.apiEndpoint[historicData]);
    return this.config?.[table]?.apiEndpoint[historicData];
  }
  getParams(table: string, column: string,paramName: any = 0) {
    //console.log('Fetching Params:', table, 'and column:', column);
    return this.config?.[table]?.columns?.[column]?.uniqueFilter?.paramName[paramName] ?? null;
  }
}
